<div class="ui vertical segment" id="scroll-container">
  <table class="ui single line table">
    <thead>
      <tr>
        <th>Affiliate Type</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let affiliateType of affiliateTypes">
        <td
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 95%;
          "
        >
          {{ affiliateType.ownershipType | titlecase }}
          <img
            style="cursor: pointer"
            src="assets/icons/deleteIcon.svg"
            alt=""
            (click)="removeIndividual.emit(affiliateType)"
            suiPopup
            [popupInverted]="true"
            popupPlacement="bottom"
            popupText="Unlink Affiliate Type"
          />
        </td>
      </tr>
    </tbody>
    <app-no-record-found
      *ngIf="affiliateTypes && affiliateTypes.length < 1"
    ></app-no-record-found>
  </table>
</div>
